module.exports = __webpack_public_path__ + "static/media/close-white.3cfde95e.svg";